import React from 'react';
import Navigation from '../../components/Navigation/Navigation';
import Carousel from '../../components/Carousel/Carousel';
import CollaboratorsMap from '../../components/CollaboratorsMap/CollaboratorsMap';
import MerchantSuggestions from '../../components/MerchantSuggestions/MerchantSuggestions';
import Footer from '../../components/Footer/Footer';
import Test from '../../components/Test/Test';


const HomePage = () => {
    return (
        <div>
            <Navigation />
            <Carousel />
            <MerchantSuggestions />
            <CollaboratorsMap/>
            <Test />
            <Footer />
        </div>
      );
}

export default HomePage;
